// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ACE_UP_YOUR_SLEEVE_TALENT: {
    id: 381828,
    name: 'Ace Up Your Sleeve',
    icon: 'inv_inscription_darkmooncard_putrescence',
    maxRanks: 2,
    entryIds: [112555],
    definitionIds: [{ id: 117560, specId: 260 }],
  },
  ACROBATIC_STRIKES_TALENT: {
    id: 455143,
    name: 'Acrobatic Strikes',
    icon: 'spell_warrior_wildstrike',
    maxRanks: 1,
    entryIds: [112551],
    definitionIds: [{ id: 117556, specId: 260 }],
  },
  ADRENALINE_RUSH_TALENT: {
    id: 13750,
    name: 'Adrenaline Rush',
    icon: 'spell_shadow_shadowworddominate',
    maxRanks: 1,
    entryIds: [112545],
    definitionIds: [{ id: 117550, specId: 260 }],
  },
  AIRBORNE_IRRITANT_TALENT: {
    id: 200733,
    name: 'Airborne Irritant',
    icon: 'ability_rogue_bloodyeye',
    maxRanks: 1,
    entryIds: [117740],
    definitionIds: [{ id: 122752, specId: 261 }],
  },
  ALACRITY_TALENT: {
    id: 193539,
    name: 'Alacrity',
    icon: 'ability_paladin_speedoflight',
    maxRanks: 2,
    entryIds: [112643],
    definitionIds: [{ id: 117648, specId: 261 }],
  },
  AMPLIFYING_POISON_TALENT: {
    id: 381664,
    name: 'Amplifying Poison',
    icon: 'inv_misc_herb_fellotus',
    maxRanks: 1,
    entryIds: [112670],
    definitionIds: [{ id: 117675, specId: 259 }],
  },
  ANCIENT_ARTS_1_SUBTLETY_TALENT: {
    id: 1268932,
    name: 'Ancient Arts',
    icon: 'inv12_apextalent_rogue_ancientarts',
    maxRanks: 1,
    entryIds: [137064],
    definitionIds: [{ id: 141827, specId: 261 }],
  },
  ANCIENT_ARTS_2_SUBTLETY_TALENT: {
    id: 1268936,
    name: 'Ancient Arts',
    icon: 'inv12_apextalent_rogue_ancientarts',
    maxRanks: 2,
    entryIds: [137063],
    definitionIds: [{ id: 141826, specId: 261 }],
  },
  ANCIENT_ARTS_3_SUBTLETY_TALENT: {
    id: 1268939,
    name: 'Ancient Arts',
    icon: 'inv12_apextalent_rogue_ancientarts',
    maxRanks: 1,
    entryIds: [137062],
    definitionIds: [{ id: 141825, specId: 261 }],
  },
  ATROPHIC_POISON_TALENT: {
    id: 381637,
    name: 'Atrophic Poison',
    icon: 'ability_rogue_nervesofsteel',
    maxRanks: 1,
    entryIds: [112655],
    definitionIds: [{ id: 117660, specId: 261 }],
  },
  AUDACITY_TALENT: {
    id: 381845,
    name: 'Audacity',
    icon: 'ability_rogue_ambush',
    maxRanks: 1,
    entryIds: [112527],
    definitionIds: [{ id: 117532, specId: 260 }],
  },
  AVULSION_TALENT: {
    id: 1250358,
    name: 'Avulsion',
    icon: 'inv_artifact_corruptedbloodofzakajz',
    maxRanks: 1,
    entryIds: [112507],
    definitionIds: [{ id: 117512, specId: 259 }],
  },
  BAIT_AND_SWITCH_TALENT: {
    id: 457034,
    name: 'Bait and Switch',
    icon: 'ability_druid_earthandsky',
    maxRanks: 1,
    entryIds: [126029],
    definitionIds: [{ id: 130861, specId: 261 }],
  },
  BLACKJACK_TALENT: {
    id: 379005,
    name: 'Blackjack',
    icon: 'ability_rogue_blackjack',
    maxRanks: 1,
    entryIds: [117143],
    definitionIds: [{ id: 122155, specId: 261 }],
  },
  BLADE_RUSH_TALENT: {
    id: 271877,
    name: 'Blade Rush',
    icon: 'ability_arakkoa_spinning_blade',
    maxRanks: 1,
    entryIds: [112535],
    definitionIds: [{ id: 117540, specId: 260 }],
  },
  BLINDING_POWDER_TALENT: {
    id: 256165,
    name: 'Blinding Powder',
    icon: 'inv_misc_ammo_gunpowder_06',
    maxRanks: 1,
    entryIds: [135733],
    definitionIds: [{ id: 140488, specId: 260 }],
  },
  BLINDSIDE_TALENT: {
    id: 328085,
    name: 'Blindside',
    icon: 'ability_rogue_focusedattacks',
    maxRanks: 1,
    entryIds: [112679],
    definitionIds: [{ id: 117684, specId: 259 }],
  },
  BLIND_TALENT: {
    id: 2094,
    name: 'Blind',
    icon: 'spell_shadow_mindsteal',
    maxRanks: 1,
    entryIds: [112572],
    definitionIds: [{ id: 117577, specId: 261 }],
  },
  BLOODY_MESS_TALENT: {
    id: 381626,
    name: 'Bloody Mess',
    icon: 'ability_rogue_rupture',
    maxRanks: 1,
    entryIds: [112518],
    definitionIds: [{ id: 117523, specId: 259 }],
  },
  CANNY_STRIKES_TALENT: {
    id: 1250359,
    name: 'Canny Strikes',
    icon: 'ability_rogue_combatexpertise',
    maxRanks: 1,
    entryIds: [112519],
    definitionIds: [{ id: 117524, specId: 259 }],
  },
  CAUSTIC_SPATTER_TALENT: {
    id: 421975,
    name: 'Caustic Spatter',
    icon: 'ability_creature_poison_02',
    maxRanks: 1,
    entryIds: [112672],
    definitionIds: [{ id: 117677, specId: 259 }],
  },
  CHEAT_DEATH_TALENT: {
    id: 31230,
    name: 'Cheat Death',
    icon: 'ability_rogue_cheatdeath',
    maxRanks: 1,
    entryIds: [114737],
    definitionIds: [{ id: 119744, specId: 261 }],
  },
  CHOSENS_REVELRY_TALENT: {
    id: 1249201,
    name: "Chosen's Revelry",
    icon: 'ability_priest_heavanlyvoice',
    maxRanks: 1,
    entryIds: [117735],
    definitionIds: [{ id: 122747, specId: 260 }],
  },
  CLEAR_THE_WITNESSES_TALENT: {
    id: 1248793,
    name: 'Clear the Witnesses',
    icon: 'ability_rogue_fanofknives',
    maxRanks: 1,
    entryIds: [117707],
    definitionIds: [{ id: 122719, specId: 261 }],
  },
  CLEVER_COMBATANT_TALENT: {
    id: 1276679,
    name: 'Clever Combatant',
    icon: 'ability_rogue_versatility',
    maxRanks: 1,
    entryIds: [136021],
    definitionIds: [{ id: 140776, specId: 261 }],
  },
  CLOAKED_IN_SHADOWS_TALENT: {
    id: 382515,
    name: 'Cloaked in Shadows',
    icon: 'inv_helm_cloth_shadowmoonclan_b_01',
    maxRanks: 1,
    entryIds: [112622],
    definitionIds: [{ id: 117627, specId: 261 }],
  },
  CLOAK_OF_SHADOWS_TALENT: {
    id: 31224,
    name: 'Cloak of Shadows',
    icon: 'spell_shadow_nethercloak',
    maxRanks: 1,
    entryIds: [112585],
    definitionIds: [{ id: 117590, specId: 261 }],
  },
  CLOUD_COVER_TALENT: {
    id: 441429,
    name: 'Cloud Cover',
    icon: 'ability_rogue_smoke',
    maxRanks: 1,
    entryIds: [117713],
    definitionIds: [{ id: 122725, specId: 261 }],
  },
  COLD_BLOODED_KILLER_TALENT: {
    id: 382245,
    name: 'Cold Blooded Killer',
    icon: 'spell_ice_lament',
    maxRanks: 1,
    entryIds: [112639],
    definitionIds: [{ id: 117644, specId: 261 }],
  },
  COMBAT_POTENCY_TALENT: {
    id: 61329,
    name: 'Combat Potency',
    icon: 'inv_weapon_shortblade_38',
    maxRanks: 1,
    entryIds: [112534],
    definitionIds: [{ id: 117539, specId: 260 }],
  },
  COMBAT_STAMINA_TALENT: {
    id: 381877,
    name: 'Combat Stamina',
    icon: 'ability_rogue_imrovedrecuperate',
    maxRanks: 1,
    entryIds: [135734],
    definitionIds: [{ id: 140489, specId: 260 }],
  },
  CONTROLLED_CHAOS_TALENT: {
    id: 1276816,
    name: 'Controlled Chaos',
    icon: 'inv_112_raidtrinkets_blobofswirlingvoid_purple',
    maxRanks: 1,
    entryIds: [136026],
    definitionIds: [{ id: 140781, specId: 260 }],
  },
  CORRUPT_THE_BLOOD_TALENT: {
    id: 1248785,
    name: 'Corrupt the Blood',
    icon: 'ability_ironmaidens_bloodritual',
    maxRanks: 1,
    entryIds: [117705],
    definitionIds: [{ id: 122717, specId: 261 }],
  },
  COUP_DE_GRACE_TALENT: {
    id: 441423,
    name: 'Coup de Grace',
    icon: 'inv_ability_tricksterrogue_coupdegrace',
    maxRanks: 1,
    entryIds: [117712],
    definitionIds: [{ id: 122724, specId: 261 }],
  },
  CRESCENDO_OF_VIOLENCE_TALENT: {
    id: 1259499,
    name: 'Crescendo of Violence',
    icon: 'ability_rogue_dirtydeeds',
    maxRanks: 1,
    entryIds: [112547],
    definitionIds: [{ id: 117552, specId: 260 }],
  },
  CRIMSON_TEMPEST_TALENT: {
    id: 1247227,
    name: 'Crimson Tempest',
    icon: 'inv12_ability_rogue_crimsontempest',
    maxRanks: 1,
    entryIds: [117139],
    definitionIds: [{ id: 122151, specId: 259 }],
    energyCost: 60,
  },
  DANCING_STEEL_TALENT: {
    id: 272026,
    name: 'Dancing Steel',
    icon: 'ability_warrior_punishingblow',
    maxRanks: 1,
    entryIds: [112556],
    definitionIds: [{ id: 117561, specId: 260 }],
  },
  DANGER_SENSE_TALENT: {
    id: 1267220,
    name: 'Danger Sense',
    icon: 'ability_rogue_wrongfullyaccused',
    maxRanks: 1,
    entryIds: [112652],
    definitionIds: [{ id: 117657, specId: 261 }],
  },
  DANSE_MACABRE_TALENT: {
    id: 382528,
    name: 'Danse Macabre',
    icon: 'ability_deathwing_bloodcorruption_death',
    maxRanks: 1,
    entryIds: [112618],
    definitionIds: [{ id: 117623, specId: 261 }],
  },
  DARKEST_NIGHT_TALENT: {
    id: 457058,
    name: 'Darkest Night',
    icon: 'spell_shadow_twilight',
    maxRanks: 1,
    entryIds: [117739],
    definitionIds: [{ id: 122751, specId: 261 }],
  },
  DARK_BREW_TALENT: {
    id: 382504,
    name: 'Dark Brew',
    icon: 'spell_nature_slowpoison',
    maxRanks: 1,
    entryIds: [112607],
    definitionIds: [{ id: 117612, specId: 261 }],
  },
  DARK_SHADOW_TALENT: {
    id: 245687,
    name: 'Dark Shadow',
    icon: 'spell_warlock_demonsoul',
    maxRanks: 2,
    entryIds: [112620],
    definitionIds: [{ id: 117625, specId: 261 }],
  },
  DASHING_SCOUNDREL_TALENT: {
    id: 381797,
    name: 'Dashing Scoundrel',
    icon: 'ability_rogue_venomouswounds',
    maxRanks: 1,
    entryIds: [112677],
    definitionIds: [{ id: 117682, specId: 259 }],
  },
  DEADENED_NERVES_TALENT: {
    id: 231719,
    name: 'Deadened Nerves',
    icon: 'ability_rogue_nervesofsteel',
    maxRanks: 1,
    entryIds: [136881],
    definitionIds: [{ id: 141644, specId: 261 }],
  },
  DEADLY_MOMENTUM_TALENT: {
    id: 1250271,
    name: 'Deadly Momentum',
    icon: 'ability_rogue_deadlymomentum',
    maxRanks: 1,
    entryIds: [112667],
    definitionIds: [{ id: 117672, specId: 259 }],
  },
  DEADLY_POISON_TALENT: {
    id: 2823,
    name: 'Deadly Poison',
    icon: 'ability_rogue_dualweild',
    maxRanks: 1,
    entryIds: [112676],
    definitionIds: [{ id: 117681, specId: 259 }],
  },
  DEADLY_PRECISION_TALENT: {
    id: 381542,
    name: 'Deadly Precision',
    icon: 'ability_rogue_deadenednerves',
    maxRanks: 1,
    entryIds: [112633],
    definitionIds: [{ id: 117638, specId: 261 }],
  },
  DEADLY_PURSUIT_TALENT: {
    id: 1259612,
    name: 'Deadly Pursuit',
    icon: 'ability_rogue_murderspree',
    maxRanks: 1,
    entryIds: [112529],
    definitionIds: [{ id: 117534, specId: 260 }],
  },
  DEAL_FATE_TALENT: {
    id: 454419,
    name: 'Deal Fate',
    icon: 'ability_rogue_preparation',
    maxRanks: 1,
    entryIds: [117704],
    definitionIds: [{ id: 122716, specId: 260 }],
  },
  DEATHMARK_TALENT: {
    id: 360194,
    name: 'Deathmark',
    icon: 'ability_rogue_deathmark',
    maxRanks: 1,
    entryIds: [112662],
    definitionIds: [{ id: 117667, specId: 259 }],
  },
  DEATHSTALKERS_MARK_TALENT: {
    id: 457052,
    name: "Deathstalker's Mark",
    icon: 'inv_ability_deathstalkerrogue_deathstalkersmark',
    maxRanks: 1,
    entryIds: [117733],
    definitionIds: [{ id: 122745, specId: 261 }],
  },
  DEATHS_ARRIVAL_TALENT: {
    id: 454433,
    name: "Death's Arrival",
    icon: 'achievement_guildperk_havegroup_willtravel',
    maxRanks: 1,
    entryIds: [125140],
    definitionIds: [{ id: 129972, specId: 260 }],
  },
  DEATH_PERCEPTION_TALENT: {
    id: 469642,
    name: 'Death Perception',
    icon: 'spell_nzinsanity_shortsighted',
    maxRanks: 2,
    entryIds: [112594],
    definitionIds: [{ id: 117599, specId: 261 }],
  },
  DEEPENING_SHADOWS_TALENT: {
    id: 185314,
    name: 'Deepening Shadows',
    icon: 'spell_shadow_twilight',
    maxRanks: 1,
    entryIds: [112612],
    definitionIds: [{ id: 117617, specId: 261 }],
  },
  DEEPER_DAGGERS_TALENT: {
    id: 382517,
    name: 'Deeper Daggers',
    icon: 'inv_weapon_shortblade_15',
    maxRanks: 1,
    entryIds: [112609],
    definitionIds: [{ id: 117614, specId: 261 }],
  },
  DEEPER_STRATAGEM_TALENT: {
    id: 193531,
    name: 'Deeper Stratagem',
    icon: 'archaeology_5_0_changkiboard',
    maxRanks: 1,
    entryIds: [112642],
    definitionIds: [{ id: 117647, specId: 261 }],
  },
  DEEP_CUTS_TALENT: {
    id: 1267216,
    name: 'Deep Cuts',
    icon: 'inv_1115_firstkilloftheday_firstkilloftheday',
    maxRanks: 1,
    entryIds: [117145],
    definitionIds: [{ id: 122157, specId: 261 }],
  },
  DEFT_MANEUVERS_TALENT: {
    id: 381878,
    name: 'Deft Maneuvers',
    icon: 'spell_warrior_wildstrike',
    maxRanks: 1,
    entryIds: [112533],
    definitionIds: [{ id: 117538, specId: 260 }],
  },
  DELIVERED_DOOM_TALENT: {
    id: 1249194,
    name: 'Delivered Doom',
    icon: 'ability_bossgorefiend_touchofdoom',
    maxRanks: 1,
    entryIds: [117716],
    definitionIds: [{ id: 122728, specId: 260 }],
  },
  DESTINY_DEFINED_TALENT: {
    id: 454435,
    name: 'Destiny Defined',
    icon: 'ability_boss_fatescribe_rune6',
    maxRanks: 1,
    entryIds: [125139],
    definitionIds: [{ id: 129971, specId: 260 }],
  },
  DEVIOUS_DISTRACTIONS_TALENT: {
    id: 441263,
    name: 'Devious Distractions',
    icon: 'ability_rogue_ghostpirate',
    maxRanks: 1,
    entryIds: [117730],
    definitionIds: [{ id: 122742, specId: 261 }],
  },
  DEVIOUS_STRATAGEM_TALENT: {
    id: 394321,
    name: 'Devious Stratagem',
    icon: 'archaeology_5_0_changkiboard',
    maxRanks: 1,
    entryIds: [112567],
    definitionIds: [{ id: 117572, specId: 260 }],
  },
  DISORIENTING_STRIKES_TALENT: {
    id: 441274,
    name: 'Disorienting Strikes',
    icon: 'petbattle_speed',
    maxRanks: 1,
    entryIds: [117715],
    definitionIds: [{ id: 122727, specId: 261 }],
  },
  DONT_BE_SUSPICIOUS_TALENT: {
    id: 441415,
    name: "Don't Be Suspicious",
    icon: 'ability_rogue_disguise',
    maxRanks: 1,
    entryIds: [120133],
    definitionIds: [{ id: 125033, specId: 261 }],
  },
  DOOMBLADE_TALENT: {
    id: 381673,
    name: 'Doomblade',
    icon: 'ability_deathwing_bloodcorruption_earth',
    maxRanks: 1,
    entryIds: [117137],
    definitionIds: [{ id: 122149, specId: 259 }],
  },
  DOUBLE_DANCE_TALENT: {
    id: 394930,
    name: 'Double Dance',
    icon: 'warrior_doubletime',
    maxRanks: 1,
    entryIds: [125619],
    definitionIds: [{ id: 130451, specId: 261 }],
  },
  DRAGON_BONE_DICE_TALENT: {
    id: 1259481,
    name: 'Dragon-Bone Dice',
    icon: 'ability_rogue_rollthebones',
    maxRanks: 1,
    entryIds: [112539],
    definitionIds: [{ id: 117544, specId: 260 }],
  },
  DRAGON_TEMPERED_BLADES_TALENT: {
    id: 381801,
    name: 'Dragon-Tempered Blades',
    icon: 'spell_fire_flameblades',
    maxRanks: 1,
    entryIds: [117131],
    definitionIds: [{ id: 122143, specId: 259 }],
  },
  ECHOING_REPRIMAND_TALENT: {
    id: 470669,
    name: 'Echoing Reprimand',
    icon: 'inv_ability_rogue_echoingreprimand',
    maxRanks: 1,
    entryIds: [112524],
    definitionIds: [{ id: 117529, specId: 261 }],
  },
  EDGE_CASE_TALENT: {
    id: 453457,
    name: 'Edge Case',
    icon: 'item_icecrownnecklacea',
    maxRanks: 1,
    entryIds: [117717],
    definitionIds: [{ id: 122729, specId: 260 }],
  },
  ELUSIVENESS_TALENT: {
    id: 79008,
    name: 'Elusiveness',
    icon: 'ability_rogue_turnthetables',
    maxRanks: 1,
    entryIds: [112632],
    definitionIds: [{ id: 117637, specId: 261 }],
  },
  EPHEMERAL_BOND_TALENT: {
    id: 426563,
    name: 'Ephemeral Bond',
    icon: 'ability_warlock_soullink',
    maxRanks: 1,
    entryIds: [136808],
    definitionIds: [{ id: 141571, specId: 261 }],
  },
  ETHEREAL_CLOAK_TALENT: {
    id: 457022,
    name: 'Ethereal Cloak',
    icon: 'spell_arcane_prismaticcloak',
    maxRanks: 1,
    entryIds: [117703],
    definitionIds: [{ id: 122715, specId: 261 }],
  },
  EVASION_TALENT: {
    id: 5277,
    name: 'Evasion',
    icon: 'spell_shadow_shadowward',
    maxRanks: 1,
    entryIds: [112654],
    definitionIds: [{ id: 117659, specId: 261 }],
  },
  EXHILARATING_EXECUTION_TALENT: {
    id: 428486,
    name: 'Exhilarating Execution',
    icon: 'inv_weapon_hand_04',
    maxRanks: 1,
    entryIds: [136807],
    definitionIds: [{ id: 141570, specId: 261 }],
  },
  EXPERT_DUELIST_TALENT: {
    id: 1259498,
    name: 'Expert Duelist',
    icon: 'inv_weapon_rifle_01',
    maxRanks: 1,
    entryIds: [112531],
    definitionIds: [{ id: 117536, specId: 260 }],
  },
  FADE_TO_NOTHING_TALENT: {
    id: 382514,
    name: 'Fade to Nothing',
    icon: 'ability_warlock_everlastingaffliction',
    maxRanks: 1,
    entryIds: [112621],
    definitionIds: [{ id: 117626, specId: 261 }],
  },
  FAN_THE_HAMMER_TALENT: {
    id: 381846,
    name: 'Fan the Hammer',
    icon: 'ability_rogue_pistolshot',
    maxRanks: 2,
    entryIds: [112553],
    definitionIds: [{ id: 117558, specId: 260 }],
  },
  FAST_ACTION_TALENT: {
    id: 1259480,
    name: 'Fast Action',
    icon: 'inv_musket_02',
    maxRanks: 1,
    entryIds: [112530],
    definitionIds: [{ id: 117535, specId: 260 }],
  },
  FATAL_CONCOCTION_TALENT: {
    id: 392384,
    name: 'Fatal Concoction',
    icon: 'ability_creature_poison_06',
    maxRanks: 2,
    entryIds: [112665],
    definitionIds: [{ id: 117670, specId: 259 }],
  },
  FATAL_FLOURISH_TALENT: {
    id: 35551,
    name: 'Fatal Flourish',
    icon: 'ability_rogue_unfairadvantage',
    maxRanks: 1,
    entryIds: [112548],
    definitionIds: [{ id: 117553, specId: 260 }],
  },
  FATE_INTERTWINED_TALENT: {
    id: 1249215,
    name: 'Fate Intertwined',
    icon: 'inv_cosmicvoid_beam',
    maxRanks: 1,
    entryIds: [117736],
    definitionIds: [{ id: 122748, specId: 260 }],
  },
  FEATHERFOOT_TALENT: {
    id: 423683,
    name: 'Featherfoot',
    icon: 'spell_magic_featherfall',
    maxRanks: 1,
    entryIds: [125615],
    definitionIds: [{ id: 130447, specId: 261 }],
  },
  FINALITY_TALENT: {
    id: 382525,
    name: 'Finality',
    icon: 'ability_rogue_eviscerate',
    maxRanks: 2,
    entryIds: [112608],
    definitionIds: [{ id: 117613, specId: 261 }],
  },
  FIND_AN_OPENING_TALENT: {
    id: 1259457,
    name: 'Find an Opening',
    icon: 'ability_rogue_pistolshot',
    maxRanks: 1,
    entryIds: [112565],
    definitionIds: [{ id: 117570, specId: 260 }],
  },
  FIND_WEAKNESS_TALENT: {
    id: 91023,
    name: 'Find Weakness',
    icon: 'ability_rogue_findweakness',
    maxRanks: 1,
    entryIds: [112578],
    definitionIds: [{ id: 117583, specId: 261 }],
  },
  FINISH_THE_JOB_TALENT: {
    id: 1249809,
    name: 'Finish the Job',
    icon: 'ability_revendreth_demonhunter',
    maxRanks: 1,
    entryIds: [112511],
    definitionIds: [{ id: 117516, specId: 259 }],
  },
  FLASHING_STEEL_TALENT: {
    id: 1276630,
    name: 'Flashing Steel',
    icon: 'inv_1115_warrior_fastermeleeattacks',
    maxRanks: 1,
    entryIds: [136022],
    definitionIds: [{ id: 140777, specId: 261 }],
  },
  FLAWLESS_FORM_TALENT: {
    id: 441321,
    name: 'Flawless Form',
    icon: 'inv_qiraj_jewelblessed',
    maxRanks: 1,
    entryIds: [117708],
    definitionIds: [{ id: 122720, specId: 261 }],
  },
  FLEET_FOOTED_TALENT: {
    id: 378813,
    name: 'Fleet Footed',
    icon: 'ability_rogue_quickrecovery',
    maxRanks: 1,
    entryIds: [112657],
    definitionIds: [{ id: 117662, specId: 261 }],
  },
  FLICKERING_STEEL_TALENT: {
    id: 1259492,
    name: 'Flickering Steel',
    icon: 'inv_1115_warrior_fastermeleeattacks',
    maxRanks: 1,
    entryIds: [135731],
    definitionIds: [{ id: 140486, specId: 260 }],
  },
  FLICKERSTRIKE_TALENT: {
    id: 441359,
    name: 'Flickerstrike',
    icon: 'spell_nature_invisibilty',
    maxRanks: 1,
    entryIds: [120131],
    definitionIds: [{ id: 125031, specId: 261 }],
  },
  FLYING_DAGGERS_TALENT: {
    id: 381631,
    name: 'Flying Daggers',
    icon: 'ability_rogue_fanofknives',
    maxRanks: 1,
    entryIds: [134837],
    definitionIds: [{ id: 139605, specId: 259 }],
  },
  FOLLOW_THE_BLOOD_TALENT: {
    id: 457068,
    name: 'Follow the Blood',
    icon: 'sha_ability_rogue_bloodyeye_nightmare',
    maxRanks: 1,
    entryIds: [126028],
    definitionIds: [{ id: 130860, specId: 261 }],
  },
  FORCED_INDUCTION_TALENT: {
    id: 470668,
    name: 'Forced Induction',
    icon: 'inv_misc_enggizmos_06',
    maxRanks: 1,
    entryIds: [112523],
    definitionIds: [{ id: 117528, specId: 261 }],
  },
  GLOOMBLADE_TALENT: {
    id: 200758,
    name: 'Gloomblade',
    icon: 'ability_ironmaidens_convulsiveshadows',
    maxRanks: 1,
    entryIds: [112587],
    definitionIds: [{ id: 117592, specId: 261 }],
    energyCost: 40,
  },
  GOREMAWS_BITE_TALENT: {
    id: 426591,
    name: "Goremaw's Bite",
    icon: 'inv_knife_1h_artifactfangs_d_01',
    maxRanks: 1,
    entryIds: [117169],
    definitionIds: [{ id: 122181, specId: 261 }],
    energyCost: 25,
  },
  GOUGE_TALENT: {
    id: 1776,
    name: 'Gouge',
    icon: 'ability_gouge',
    maxRanks: 1,
    entryIds: [112631],
    definitionIds: [{ id: 117636, specId: 261 }],
    energyCost: 25,
  },
  GRACEFUL_GUILE_TALENT: {
    id: 423647,
    name: 'Graceful Guile',
    icon: 'ability_rogue_ghostpirate',
    maxRanks: 1,
    entryIds: [112646],
    definitionIds: [{ id: 117651, specId: 261 }],
  },
  GRAND_MELEE_TALENT: {
    id: 1259469,
    name: 'Grand Melee',
    icon: 'ability_rogue_rollthebones02',
    maxRanks: 1,
    entryIds: [112554],
    definitionIds: [{ id: 117559, specId: 260 }],
  },
  GRAVEDIGGER_1_OUTLAW_TALENT: {
    id: 1265861,
    name: 'Gravedigger',
    icon: 'inv12_apextalent_rogue_gravedigger',
    maxRanks: 1,
    entryIds: [137070],
    definitionIds: [{ id: 141834, specId: 260 }],
  },
  GRAVEDIGGER_2_OUTLAW_TALENT: {
    id: 1265862,
    name: 'Gravedigger',
    icon: 'inv12_apextalent_rogue_gravedigger',
    maxRanks: 2,
    entryIds: [137069],
    definitionIds: [{ id: 141833, specId: 260 }],
  },
  GRAVEDIGGER_3_OUTLAW_TALENT: {
    id: 1265863,
    name: 'Gravedigger',
    icon: 'inv12_apextalent_rogue_gravedigger',
    maxRanks: 1,
    entryIds: [137068],
    definitionIds: [{ id: 141832, specId: 260 }],
  },
  HAND_OF_FATE_TALENT: {
    id: 452536,
    name: 'Hand of Fate',
    icon: 'inv_ability_fateboundrogue_handoffateheads',
    maxRanks: 1,
    entryIds: [117722],
    definitionIds: [{ id: 122734, specId: 260 }],
  },
  HEAVY_HITTER_TALENT: {
    id: 381885,
    name: 'Heavy Hitter',
    icon: 'spell_shadow_ritualofsacrifice',
    maxRanks: 2,
    entryIds: [112566],
    definitionIds: [{ id: 117571, specId: 260 }],
  },
  HEIGHTENED_RUSH_TALENT: {
    id: 1259465,
    name: 'Heightened Rush',
    icon: 'spell_shadow_unholyfrenzy',
    maxRanks: 1,
    entryIds: [112541],
    definitionIds: [{ id: 117546, specId: 260 }],
  },
  HIDDEN_OPPORTUNITY_TALENT: {
    id: 383281,
    name: 'Hidden Opportunity',
    icon: 'ability_rogue_ambush',
    maxRanks: 1,
    entryIds: [112562],
    definitionIds: [{ id: 117567, specId: 260 }],
  },
  HIT_AND_RUN_TALENT: {
    id: 196922,
    name: 'Hit and Run',
    icon: 'ability_rogue_fleetfooted',
    maxRanks: 1,
    entryIds: [112569],
    definitionIds: [{ id: 117574, specId: 260 }],
  },
  HOODWINK_TALENT: {
    id: 1276626,
    name: 'Hoodwink',
    icon: 'spell_holy_dizzy',
    maxRanks: 1,
    entryIds: [136023],
    definitionIds: [{ id: 140778, specId: 261 }],
  },
  HUNT_THEM_DOWN_TALENT: {
    id: 457054,
    name: 'Hunt Them Down',
    icon: 'ability_rogue_creepingvenom',
    maxRanks: 1,
    entryIds: [117729],
    definitionIds: [{ id: 122741, specId: 261 }],
  },
  IMPLACABLE_1_ASSASSINATION_TALENT: {
    id: 1265385,
    name: 'Implacable',
    icon: 'inv12_apextalent_rogue_implacable',
    maxRanks: 1,
    entryIds: [137067],
    definitionIds: [{ id: 141831, specId: 259 }],
  },
  IMPLACABLE_2_ASSASSINATION_TALENT: {
    id: 1265386,
    name: 'Implacable',
    icon: 'inv12_apextalent_rogue_implacable',
    maxRanks: 2,
    entryIds: [137066],
    definitionIds: [{ id: 141830, specId: 259 }],
  },
  IMPLACABLE_3_ASSASSINATION_TALENT: {
    id: 1265387,
    name: 'Implacable',
    icon: 'inv12_apextalent_rogue_implacable',
    maxRanks: 1,
    entryIds: [137065],
    definitionIds: [{ id: 141829, specId: 259 }],
  },
  IMPROVED_ADRENALINE_RUSH_TALENT: {
    id: 395422,
    name: 'Improved Adrenaline Rush',
    icon: 'spell_shadow_shadowworddominate',
    maxRanks: 1,
    entryIds: [112540],
    definitionIds: [{ id: 117545, specId: 260 }],
  },
  IMPROVED_AMBUSH_TALENT: {
    id: 381620,
    name: 'Improved Ambush',
    icon: 'ability_rogue_ambush',
    maxRanks: 1,
    entryIds: [112580],
    definitionIds: [{ id: 117585, specId: 261 }],
  },
  IMPROVED_BACKSTAB_TALENT: {
    id: 319949,
    name: 'Improved Backstab',
    icon: 'ability_backstab',
    maxRanks: 1,
    entryIds: [112629],
    definitionIds: [{ id: 117634, specId: 261 }],
  },
  IMPROVED_BETWEEN_THE_EYES_TALENT: {
    id: 235484,
    name: 'Improved Between the Eyes',
    icon: 'ability_rogue_rollthebones01',
    maxRanks: 1,
    entryIds: [112645],
    definitionIds: [{ id: 117650, specId: 260 }],
  },
  IMPROVED_FIND_WEAKNESS_TALENT: {
    id: 382512,
    name: 'Improved Find Weakness',
    icon: 'ability_rogue_findweakness',
    maxRanks: 1,
    entryIds: [112592],
    definitionIds: [{ id: 117597, specId: 261 }],
  },
  IMPROVED_GARROTE_TALENT: {
    id: 381632,
    name: 'Improved Garrote',
    icon: 'ability_rogue_garrote',
    maxRanks: 1,
    entryIds: [112510],
    definitionIds: [{ id: 117515, specId: 259 }],
  },
  IMPROVED_POISONS_TALENT: {
    id: 381624,
    name: 'Improved Poisons',
    icon: 'ability_poisons',
    maxRanks: 1,
    entryIds: [112520],
    definitionIds: [{ id: 117525, specId: 259 }],
  },
  IMPROVED_SECRET_TECHNIQUE_TALENT: {
    id: 1279444,
    name: 'Improved Secret Technique',
    icon: 'ability_rogue_sinistercalling',
    maxRanks: 1,
    entryIds: [112603],
    definitionIds: [{ id: 117608, specId: 261 }],
  },
  IMPROVED_SHURIKEN_STORM_TALENT: {
    id: 319951,
    name: 'Improved Shuriken Storm',
    icon: 'ability_rogue_shuriken_storm',
    maxRanks: 1,
    entryIds: [112598],
    definitionIds: [{ id: 117603, specId: 261 }],
  },
  IMPROVED_SPRINT_TALENT: {
    id: 231691,
    name: 'Improved Sprint',
    icon: 'ability_rogue_sprint',
    maxRanks: 1,
    entryIds: [112575],
    definitionIds: [{ id: 117580, specId: 261 }],
  },
  IMPROVED_WOUND_POISON_TALENT: {
    id: 319066,
    name: 'Improved Wound Poison',
    icon: 'inv_misc_herb_16',
    maxRanks: 1,
    entryIds: [112522],
    definitionIds: [{ id: 117527, specId: 261 }],
  },
  INEXORABLE_MARCH_TALENT: {
    id: 454432,
    name: 'Inexorable March',
    icon: 'ability_monk_ridethewind',
    maxRanks: 1,
    entryIds: [117727],
    definitionIds: [{ id: 122739, specId: 260 }],
  },
  INSPIRING_STRIKE_TALENT: {
    id: 1250036,
    name: 'Inspiring Strike',
    icon: 'ability_rogue_disembowel',
    maxRanks: 1,
    entryIds: [112660],
    definitionIds: [{ id: 117665, specId: 259 }],
  },
  INTENT_TO_KILL_TALENT: {
    id: 381630,
    name: 'Intent to Kill',
    icon: 'ability_rogue_bloodyeye',
    maxRanks: 1,
    entryIds: [134839],
    definitionIds: [{ id: 139607, specId: 259 }],
  },
  INTERNAL_BLEEDING_TALENT: {
    id: 381627,
    name: 'Internal Bleeding',
    icon: 'ability_rogue_bloodsplatter',
    maxRanks: 1,
    entryIds: [134840],
    definitionIds: [{ id: 139608, specId: 259 }],
  },
  IRON_STOMACH_TALENT: {
    id: 193546,
    name: 'Iron Stomach',
    icon: 'inv_misc_organ_11',
    maxRanks: 1,
    entryIds: [112634],
    definitionIds: [{ id: 117639, specId: 261 }],
  },
  IRON_WIRE_TALENT: {
    id: 196861,
    name: 'Iron Wire',
    icon: 'inv_jewelcrafting_delicatecopperwire',
    maxRanks: 1,
    entryIds: [134838],
    definitionIds: [{ id: 139606, specId: 259 }],
  },
  KEEP_IT_ROLLING_TALENT: {
    id: 381989,
    name: 'Keep It Rolling',
    icon: 'ability_rogue_keepitrolling',
    maxRanks: 1,
    entryIds: [112538],
    definitionIds: [{ id: 117543, specId: 260 }],
  },
  KILLING_SPREE_TALENT: {
    id: 51690,
    name: 'Killing Spree',
    icon: 'inv_112_rogue_betweentheeyes',
    maxRanks: 1,
    entryIds: [117148],
    definitionIds: [{ id: 122160, specId: 260 }],
    energyCost: 45,
    comboPointsCost: 1,
  },
  KINGSBANE_TALENT: {
    id: 385627,
    name: 'Kingsbane',
    icon: 'inv_knife_1h_artifactgarona_d_01',
    maxRanks: 1,
    entryIds: [112663],
    definitionIds: [{ id: 117668, specId: 259 }],
    energyCost: 35,
  },
  LEECHING_POISON_TALENT: {
    id: 280716,
    name: 'Leeching Poison',
    icon: 'rogue_leeching_poison',
    maxRanks: 1,
    entryIds: [112650],
    definitionIds: [{ id: 117655, specId: 261 }],
  },
  LETHALITY_TALENT: {
    id: 382238,
    name: 'Lethality',
    icon: 'ability_criticalstrike',
    maxRanks: 2,
    entryIds: [112640],
    definitionIds: [{ id: 117645, specId: 261 }],
  },
  LETHAL_DOSE_TALENT: {
    id: 381640,
    name: 'Lethal Dose',
    icon: 'ability_rogue_deviouspoisons',
    maxRanks: 2,
    entryIds: [112509],
    definitionIds: [{ id: 117514, specId: 259 }],
  },
  LINGERING_DARKNESS_TALENT: {
    id: 457056,
    name: 'Lingering Darkness',
    icon: 'ability_rogue_envelopingshadows',
    maxRanks: 1,
    entryIds: [117706],
    definitionIds: [{ id: 122718, specId: 261 }],
  },
  LINGERING_SHADOW_TALENT: {
    id: 382524,
    name: 'Lingering Shadow',
    icon: 'spell_fire_twilightnova',
    maxRanks: 1,
    entryIds: [112619],
    definitionIds: [{ id: 117624, specId: 261 }],
  },
  LOADED_DICE_TALENT: {
    id: 256170,
    name: 'Loaded Dice',
    icon: 'ability_rogue_rollthebones',
    maxRanks: 1,
    entryIds: [112542],
    definitionIds: [{ id: 117547, specId: 260 }],
  },
  LUCKY_COIN_TALENT: {
    id: 1248970,
    name: 'Lucky Coin',
    icon: 'inv_misc_markoftheworldtree',
    maxRanks: 1,
    entryIds: [117724],
    definitionIds: [{ id: 122736, specId: 260 }],
  },
  MASS_CASUALTY_TALENT: {
    id: 1273035,
    name: 'Mass Casualty',
    icon: 'ability_hunter_rapidkilling',
    maxRanks: 1,
    entryIds: [136018],
    definitionIds: [{ id: 140773, specId: 261 }],
  },
  MASTER_OF_SHADOWS_TALENT: {
    id: 196976,
    name: 'Master of Shadows',
    icon: 'spell_shadow_charm',
    maxRanks: 1,
    entryIds: [112615],
    definitionIds: [{ id: 117620, specId: 261 }],
  },
  MASTER_POISONER_TALENT: {
    id: 378436,
    name: 'Master Poisoner',
    icon: 'ability_creature_poison_06',
    maxRanks: 1,
    entryIds: [112521],
    definitionIds: [{ id: 117526, specId: 261 }],
  },
  MEAN_STREAK_TALENT: {
    id: 453428,
    name: 'Mean Streak',
    icon: 'inv_sigil_thorim',
    maxRanks: 1,
    entryIds: [117719],
    definitionIds: [{ id: 122731, specId: 260 }],
  },
  MENACING_RUSH_TALENT: {
    id: 1256630,
    name: 'Menacing Rush',
    icon: 'inv_1115_warrior_fasterreflexes',
    maxRanks: 1,
    entryIds: [135732],
    definitionIds: [{ id: 140487, specId: 260 }],
  },
  MIRRORS_TALENT: {
    id: 441250,
    name: 'Mirrors',
    icon: 'trade_archaeology_highbornesoulmirror',
    maxRanks: 1,
    entryIds: [120130],
    definitionIds: [{ id: 125030, specId: 261 }],
  },
  MOMENTUM_OF_DESPAIR_TALENT: {
    id: 457067,
    name: 'Momentum of Despair',
    icon: 'spell_shadow_shadesofdarkness',
    maxRanks: 1,
    entryIds: [117728],
    definitionIds: [{ id: 122740, specId: 261 }],
  },
  MOTIVATED_MURDERER_TALENT: {
    id: 1247993,
    name: 'Motivated Murderer',
    icon: 'ability_rogue_deadliness',
    maxRanks: 1,
    entryIds: [112513],
    definitionIds: [{ id: 117518, specId: 259 }],
  },
  NEGOTIABLE_CONTRACT_TALENT: {
    id: 1292996,
    name: 'Negotiable Contract',
    icon: 'ability_revendreth_rogue',
    maxRanks: 1,
    entryIds: [137379],
    definitionIds: [{ id: 142139, specId: 259 }],
  },
  NIGHT_TERRORS_TALENT: {
    id: 277953,
    name: 'Night Terrors',
    icon: 'spell_shadow_shadesofdarkness',
    maxRanks: 1,
    entryIds: [112602],
    definitionIds: [{ id: 117607, specId: 261 }],
  },
  NIMBLE_FINGERS_TALENT: {
    id: 378427,
    name: 'Nimble Fingers',
    icon: 'ability_rogue_crimsonvial',
    maxRanks: 1,
    entryIds: [112635],
    definitionIds: [{ id: 117640, specId: 261 }],
  },
  NIMBLE_FLURRY_TALENT: {
    id: 441367,
    name: 'Nimble Flurry',
    icon: 'ability_rogue_bladetwisting',
    maxRanks: 1,
    entryIds: [117725],
    definitionIds: [{ id: 122737, specId: 261 }],
  },
  NO_SCRUPLES_TALENT: {
    id: 441398,
    name: 'No Scruples',
    icon: 'ability_rogue_surpriseattack',
    maxRanks: 1,
    entryIds: [120132],
    definitionIds: [{ id: 125032, specId: 261 }],
  },
  NUMBING_POISON_TALENT: {
    id: 5761,
    name: 'Numbing Poison',
    icon: 'spell_nature_nullifydisease',
    maxRanks: 1,
    entryIds: [112656],
    definitionIds: [{ id: 117661, specId: 261 }],
  },
  OPPORTUNITY_TALENT: {
    id: 279876,
    name: 'Opportunity',
    icon: 'ability_rogue_pistolshot',
    maxRanks: 1,
    entryIds: [112571],
    definitionIds: [{ id: 117576, specId: 260 }],
  },
  OVERFLOWING_PURSE_TALENT: {
    id: 1249190,
    name: 'Overflowing Purse',
    icon: 'inv_misc_coinbag_special',
    maxRanks: 1,
    entryIds: [117711],
    definitionIds: [{ id: 122723, specId: 260 }],
  },
  PATH_OF_BLOOD_TALENT: {
    id: 423054,
    name: 'Path of Blood',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [117106],
    definitionIds: [{ id: 122118, specId: 259 }],
  },
  PERFORATED_VEINS_TALENT: {
    id: 382518,
    name: 'Perforated Veins',
    icon: 'ability_warrior_bloodfrenzy',
    maxRanks: 1,
    entryIds: [112595],
    definitionIds: [{ id: 117600, specId: 261 }],
  },
  PLANNED_EXECUTION_TALENT: {
    id: 382508,
    name: 'Planned Execution',
    icon: 'ability_creature_cursed_02',
    maxRanks: 1,
    entryIds: [112591],
    definitionIds: [{ id: 117596, specId: 261 }],
  },
  POISONERS_DRIVE_TALENT: {
    id: 1250318,
    name: "Poisoner's Drive",
    icon: 'inv_ability_rogue_sepsis',
    maxRanks: 1,
    entryIds: [134835],
    definitionIds: [{ id: 139603, specId: 259 }],
  },
  POISON_BOMB_TALENT: {
    id: 255544,
    name: 'Poison Bomb',
    icon: 'rogue_paralytic_poison',
    maxRanks: 1,
    entryIds: [117135],
    definitionIds: [{ id: 122147, specId: 259 }],
  },
  POTENT_POWDER_TALENT: {
    id: 1265952,
    name: 'Potent Powder',
    icon: 'spell_priest_divinestar_shadow',
    maxRanks: 1,
    entryIds: [112606],
    definitionIds: [{ id: 117611, specId: 261 }],
  },
  PRECISE_KILLER_TALENT: {
    id: 1272989,
    name: 'Precise Killer',
    icon: 'inv_tradeskillitem_sorcererswind',
    maxRanks: 1,
    entryIds: [136020],
    definitionIds: [{ id: 140775, specId: 261 }],
  },
  PRECISION_SHOT_TALENT: {
    id: 428377,
    name: 'Precision Shot',
    icon: 'inv_legendary_gun',
    maxRanks: 1,
    entryIds: [112647],
    definitionIds: [{ id: 117652, specId: 260 }],
  },
  PREMEDITATION_TALENT: {
    id: 343160,
    name: 'Premeditation',
    icon: 'spell_shadow_possession',
    maxRanks: 1,
    entryIds: [112588],
    definitionIds: [{ id: 117593, specId: 261 }],
  },
  PREPARATION_TALENT: {
    id: 1277933,
    name: 'Preparation',
    icon: 'ability_rogue_preparation',
    maxRanks: 1,
    entryIds: [112552],
    definitionIds: [{ id: 117557, specId: 260 }],
  },
  QUICK_DECISIONS_TALENT: {
    id: 382503,
    name: 'Quick Decisions',
    icon: 'inv_misc_hook_01',
    maxRanks: 1,
    entryIds: [112616],
    definitionIds: [{ id: 117621, specId: 261 }],
  },
  QUICK_DRAW_TALENT: {
    id: 196938,
    name: 'Quick Draw',
    icon: 'inv_weapon_rifle_40',
    maxRanks: 1,
    entryIds: [112549],
    definitionIds: [{ id: 117554, specId: 260 }],
  },
  QUICK_FINGERS_TALENT: {
    id: 1267210,
    name: 'Quick Fingers',
    icon: 'ability_rogue_improvedrecuperate',
    maxRanks: 1,
    entryIds: [112636],
    definitionIds: [{ id: 117641, specId: 261 }],
  },
  QUIETUS_CELERIS_TALENT: {
    id: 1273017,
    name: 'Quietus Celeris',
    icon: 'ability_argus_deathfog',
    maxRanks: 1,
    entryIds: [136019],
    definitionIds: [{ id: 140774, specId: 261 }],
  },
  RAPID_INJECTION_TALENT: {
    id: 455072,
    name: 'Rapid Injection',
    icon: 'inv_ammo_arrow_04',
    maxRanks: 2,
    entryIds: [112659],
    definitionIds: [{ id: 117664, specId: 259 }],
  },
  RAVENHOLDT_MINT_TALENT: {
    id: 1276809,
    name: 'Ravenholdt Mint',
    icon: 'inv_misc_coin_02',
    maxRanks: 1,
    entryIds: [136024],
    definitionIds: [{ id: 140779, specId: 260 }],
  },
  RAZOR_WIRE_TALENT: {
    id: 1249802,
    name: 'Razor Wire',
    icon: 'ability_hunter_razorwire',
    maxRanks: 1,
    entryIds: [112673],
    definitionIds: [{ id: 117678, specId: 259 }],
  },
  RECUPERATOR_TALENT: {
    id: 378996,
    name: 'Recuperator',
    icon: 'inv_gizmo_runichealthinjector',
    maxRanks: 1,
    entryIds: [112526],
    definitionIds: [{ id: 117531, specId: 261 }],
  },
  REGICIDES_REWARD_TALENT: {
    id: 1250325,
    name: "Regicide's Reward",
    icon: 'inv_knife_1h_artifactfangs_d_02',
    maxRanks: 1,
    entryIds: [117130],
    definitionIds: [{ id: 122142, specId: 259 }],
  },
  RELENTLESS_STRIKES_TALENT: {
    id: 58423,
    name: 'Relentless Strikes',
    icon: 'ability_warrior_decisivestrike',
    maxRanks: 1,
    entryIds: [112597],
    definitionIds: [{ id: 117602, specId: 261 }],
  },
  REPLICATING_SHADOWS_TALENT: {
    id: 382506,
    name: 'Replicating Shadows',
    icon: 'spell_deathknight_strangulate',
    maxRanks: 1,
    entryIds: [112604],
    definitionIds: [{ id: 117609, specId: 261 }],
  },
  RETRACTABLE_HOOK_TALENT: {
    id: 256188,
    name: 'Retractable Hook',
    icon: 'ability_rogue_grapplinghook',
    maxRanks: 1,
    entryIds: [112560],
    definitionIds: [{ id: 117565, specId: 260 }],
  },
  RUSH_TO_THE_INEVITABLE_TALENT: {
    id: 1249204,
    name: 'Rush to the Inevitable',
    icon: 'ability_rogue_vigor',
    maxRanks: 1,
    entryIds: [117726],
    definitionIds: [{ id: 122738, specId: 260 }],
  },
  RUTHLESSNESS_TALENT: {
    id: 14161,
    name: 'Ruthlessness',
    icon: 'ability_druid_disembowel',
    maxRanks: 1,
    entryIds: [112568],
    definitionIds: [{ id: 117573, specId: 260 }],
  },
  SANGUINE_STRATAGEM_TALENT: {
    id: 457512,
    name: 'Sanguine Stratagem',
    icon: 'archaeology_5_0_changkiboard',
    maxRanks: 1,
    entryIds: [117133],
    definitionIds: [{ id: 122145, specId: 259 }],
  },
  SANGUINE_VIAL_TALENT: {
    id: 1293135,
    name: 'Sanguine Vial',
    icon: 'inv_misc_potiona5',
    maxRanks: 1,
    entryIds: [137380],
    definitionIds: [{ id: 142140, specId: 261 }],
  },
  SCENT_OF_BLOOD_TALENT: {
    id: 381799,
    name: 'Scent of Blood',
    icon: 'ability_rogue_rupture',
    maxRanks: 2,
    entryIds: [112668],
    definitionIds: [{ id: 117673, specId: 259 }],
  },
  SEAL_FATE_TALENT: {
    id: 14190,
    name: 'Seal Fate',
    icon: 'ability_rogue_stayofexecution',
    maxRanks: 1,
    entryIds: [112649],
    definitionIds: [{ id: 117654, specId: 259 }],
  },
  SECONDARY_POISONING_TALENT: {
    id: 1250141,
    name: 'Secondary Poisoning',
    icon: 'ability_poisons',
    maxRanks: 1,
    entryIds: [134836],
    definitionIds: [{ id: 139604, specId: 259 }],
  },
  SECRET_STRATAGEM_TALENT: {
    id: 394320,
    name: 'Secret Stratagem',
    icon: 'archaeology_5_0_changkiboard',
    maxRanks: 1,
    entryIds: [112610],
    definitionIds: [{ id: 117615, specId: 261 }],
  },
  SHADEWALKER_TALENT: {
    id: 457057,
    name: 'Shadewalker',
    icon: 'rogue_shadow_reflection',
    maxRanks: 1,
    entryIds: [117720],
    definitionIds: [{ id: 122732, specId: 261 }],
  },
  SHADOWCRAFT_TALENT: {
    id: 426594,
    name: 'Shadowcraft',
    icon: 'spell_shadow_sealofkings',
    maxRanks: 1,
    entryIds: [117168],
    definitionIds: [{ id: 122180, specId: 261 }],
  },
  SHADOWED_FINISHERS_TALENT: {
    id: 382511,
    name: 'Shadowed Finishers',
    icon: 'ability_rogue_eviscerate',
    maxRanks: 1,
    entryIds: [112611],
    definitionIds: [{ id: 117616, specId: 261 }],
  },
  SHADOWRUNNER_TALENT: {
    id: 378807,
    name: 'Shadowrunner',
    icon: 'ability_stealth',
    maxRanks: 1,
    entryIds: [136882],
    definitionIds: [{ id: 141645, specId: 261 }],
  },
  SHADOW_BLADES_TALENT: {
    id: 121471,
    name: 'Shadow Blades',
    icon: 'inv_knife_1h_grimbatolraid_d_03',
    maxRanks: 1,
    entryIds: [112614],
    definitionIds: [{ id: 117619, specId: 261 }],
  },
  SHADOW_FOCUS_TALENT: {
    id: 108209,
    name: 'Shadow Focus',
    icon: 'rogue_shadowfocus',
    maxRanks: 1,
    entryIds: [112623],
    definitionIds: [{ id: 117628, specId: 261 }],
  },
  SHIV_TALENT: {
    id: 5938,
    name: 'Shiv',
    icon: 'inv_throwingknife_04',
    maxRanks: 1,
    entryIds: [112630],
    definitionIds: [{ id: 117635, specId: 261 }],
    energyCost: 30,
  },
  SHOT_IN_THE_DARK_TALENT: {
    id: 257505,
    name: 'Shot in the Dark',
    icon: 'ability_cheapshot',
    maxRanks: 1,
    entryIds: [112589],
    definitionIds: [{ id: 117594, specId: 261 }],
  },
  SHROUDED_IN_DARKNESS_TALENT: {
    id: 382507,
    name: 'Shrouded in Darkness',
    icon: 'ability_rogue_envelopingshadows',
    maxRanks: 1,
    entryIds: [112586],
    definitionIds: [{ id: 117591, specId: 261 }],
  },
  SHROUDED_SUFFOCATION_TALENT: {
    id: 385478,
    name: 'Shrouded Suffocation',
    icon: 'ability_rogue_garrote',
    maxRanks: 1,
    entryIds: [112669],
    definitionIds: [{ id: 117674, specId: 259 }],
  },
  SHROUD_OF_NIGHT_TALENT: {
    id: 457063,
    name: 'Shroud of Night',
    icon: 'spell_holy_elunesgrace',
    maxRanks: 1,
    entryIds: [126027],
    definitionIds: [{ id: 130859, specId: 261 }],
  },
  SHURIKEN_TORNADO_TALENT: {
    id: 1264764,
    name: 'Shuriken Tornado',
    icon: 'ability_rogue_throwingspecialization',
    maxRanks: 1,
    entryIds: [112605],
    definitionIds: [{ id: 117610, specId: 261 }],
  },
  SILENT_STORM_TALENT: {
    id: 385722,
    name: 'Silent Storm',
    icon: 'ability_rogue_shuriken_storm',
    maxRanks: 1,
    entryIds: [117170],
    definitionIds: [{ id: 122182, specId: 261 }],
  },
  SINGULAR_FOCUS_TALENT: {
    id: 457055,
    name: 'Singular Focus',
    icon: 'spell_hunter_focusingshot',
    maxRanks: 1,
    entryIds: [117714],
    definitionIds: [{ id: 122726, specId: 261 }],
  },
  SLEIGHT_OF_HAND_TALENT: {
    id: 381839,
    name: 'Sleight of Hand',
    icon: 'inv_misc_dice_02',
    maxRanks: 1,
    entryIds: [112537],
    definitionIds: [{ id: 117542, specId: 260 }],
  },
  SMOKE_TALENT: {
    id: 441247,
    name: 'Smoke',
    icon: 'rogue_dirtytricks',
    maxRanks: 1,
    entryIds: [117738],
    definitionIds: [{ id: 122750, specId: 261 }],
  },
  SOMETIMES_LUCKY_TALENT: {
    id: 1277030,
    name: 'Sometimes Lucky',
    icon: 'inv_misc_celestialmap',
    maxRanks: 1,
    entryIds: [136025],
    definitionIds: [{ id: 140780, specId: 260 }],
  },
  SOOTHING_DARKNESS_TALENT: {
    id: 393970,
    name: 'Soothing Darkness',
    icon: 'spell_shadow_twilight',
    maxRanks: 1,
    entryIds: [112579],
    definitionIds: [{ id: 117584, specId: 261 }],
  },
  SO_TRICKY_TALENT: {
    id: 441403,
    name: 'So Tricky',
    icon: 'ability_rogue_tricksofthetrade',
    maxRanks: 1,
    entryIds: [117731],
    definitionIds: [{ id: 122743, specId: 261 }],
  },
  STILLSHROUD_TALENT: {
    id: 423662,
    name: 'Stillshroud',
    icon: 'ability_rogue_shroudofconcealment',
    maxRanks: 1,
    entryIds: [117146],
    definitionIds: [{ id: 122158, specId: 261 }],
  },
  SUBTERFUGE_TALENT: {
    id: 108208,
    name: 'Subterfuge',
    icon: 'rogue_subterfuge',
    maxRanks: 2,
    entryIds: [112576],
    definitionIds: [{ id: 117581, specId: 261 }],
  },
  SUDDEN_DEMISE_TALENT: {
    id: 423136,
    name: 'Sudden Demise',
    icon: 'ability_deathknight_hemorrhagicfever',
    maxRanks: 1,
    entryIds: [117129],
    definitionIds: [{ id: 122141, specId: 259 }],
  },
  SUMMARILY_DISPATCHED_TALENT: {
    id: 381990,
    name: 'Summarily Dispatched',
    icon: 'ability_rogue_waylay',
    maxRanks: 2,
    entryIds: [112563],
    definitionIds: [{ id: 117568, specId: 260 }],
  },
  SUPERCHARGER_TALENT: {
    id: 470347,
    name: 'Supercharger',
    icon: 'inv_engineering_90_electrifiedether',
    maxRanks: 2,
    entryIds: [112525],
    definitionIds: [{ id: 117530, specId: 261 }],
  },
  SUPERIOR_MIXTURE_TALENT: {
    id: 423701,
    name: 'Superior Mixture',
    icon: 'inv_misc_potionsete',
    maxRanks: 1,
    entryIds: [117151],
    definitionIds: [{ id: 122163, specId: 261 }],
  },
  SURPRISING_STRIKES_TALENT: {
    id: 441273,
    name: 'Surprising Strikes',
    icon: 'ability_rogue_surpriseattack2',
    maxRanks: 1,
    entryIds: [117718],
    definitionIds: [{ id: 122730, specId: 261 }],
  },
  SWIFT_SLASHER_TALENT: {
    id: 381988,
    name: 'Swift Slasher',
    icon: 'ability_rogue_slicedice',
    maxRanks: 1,
    entryIds: [112644],
    definitionIds: [{ id: 117649, specId: 261 }],
  },
  SYMBOLIC_VICTORY_TALENT: {
    id: 457062,
    name: 'Symbolic Victory',
    icon: 'ability_priest_surgeofdarkness',
    maxRanks: 1,
    entryIds: [126030],
    definitionIds: [{ id: 130862, specId: 261 }],
  },
  SYSTEMIC_FAILURE_TALENT: {
    id: 381652,
    name: 'Systemic Failure',
    icon: 'ability_skeer_bloodletting',
    maxRanks: 1,
    entryIds: [112664],
    definitionIds: [{ id: 117669, specId: 259 }],
  },
  TEMPTED_FATE_TALENT: {
    id: 454286,
    name: 'Tempted Fate',
    icon: 'ability_rogue_sabreslash',
    maxRanks: 1,
    entryIds: [125132],
    definitionIds: [{ id: 129964, specId: 260 }],
  },
  TERRIFYING_PACE_TALENT: {
    id: 428387,
    name: 'Terrifying Pace',
    icon: 'ability_druid_typhoon',
    maxRanks: 1,
    entryIds: [136488],
    definitionIds: [{ id: 141261, specId: 261 }],
  },
  THE_FIRST_DANCE_TALENT: {
    id: 382505,
    name: 'The First Dance',
    icon: 'ability_rogue_shadowdance',
    maxRanks: 1,
    entryIds: [112625],
    definitionIds: [{ id: 117630, specId: 261 }],
  },
  THE_ROTTEN_TALENT: {
    id: 382015,
    name: 'The Rotten',
    icon: 'spell_shadow_nightofthedead',
    maxRanks: 1,
    entryIds: [112593],
    definitionIds: [{ id: 117598, specId: 261 }],
  },
  THIEFS_VERSATILITY_TALENT: {
    id: 381619,
    name: "Thief's Versatility",
    icon: 'ability_rogue_versatility',
    maxRanks: 1,
    entryIds: [112558],
    definitionIds: [{ id: 117563, specId: 260 }],
  },
  THISTLE_TEA_TALENT: {
    id: 469779,
    name: 'Thistle Tea',
    icon: 'inv_drink_milk_05',
    maxRanks: 1,
    entryIds: [112648],
    definitionIds: [{ id: 117653, specId: 261 }],
  },
  THOUSAND_CUTS_TALENT: {
    id: 441346,
    name: 'Thousand Cuts',
    icon: 'inv_10_specialization_blacksmithing_blades_color1',
    maxRanks: 1,
    entryIds: [117734],
    definitionIds: [{ id: 122746, specId: 261 }],
  },
  THRILL_SEEKING_TALENT: {
    id: 394931,
    name: 'Thrill Seeking',
    icon: 'inv_ragnaros_heart_shadowflame',
    maxRanks: 1,
    entryIds: [112583],
    definitionIds: [{ id: 117588, specId: 261 }],
  },
  THROWN_PRECISION_TALENT: {
    id: 381629,
    name: 'Thrown Precision',
    icon: 'ability_hunter_cobrashot',
    maxRanks: 1,
    entryIds: [112515],
    definitionIds: [{ id: 117520, specId: 259 }],
  },
  TIGHT_SPENDER_TALENT: {
    id: 381621,
    name: 'Tight Spender',
    icon: 'inv_misc_coin_03',
    maxRanks: 1,
    entryIds: [117152],
    definitionIds: [{ id: 122164, specId: 261 }],
  },
  TOXIC_STILETTO_TALENT: {
    id: 1267182,
    name: 'Toxic Stiletto',
    icon: 'ability_rogue_poisonedknife',
    maxRanks: 1,
    entryIds: [136883],
    definitionIds: [{ id: 141646, specId: 261 }],
  },
  TRICKS_OF_THE_TRADE_TALENT: {
    id: 57934,
    name: 'Tricks of the Trade',
    icon: 'ability_rogue_tricksofthetrade',
    maxRanks: 1,
    entryIds: [112574],
    definitionIds: [{ id: 117579, specId: 261 }],
  },
  UMBRAL_EDGE_TALENT: {
    id: 1281468,
    name: 'Umbral Edge',
    icon: 'ability_rogue_nightblade',
    maxRanks: 1,
    entryIds: [112628],
    definitionIds: [{ id: 117633, specId: 261 }],
  },
  UNBREAKABLE_STRIDE_TALENT: {
    id: 400804,
    name: 'Unbreakable Stride',
    icon: 'ability_rogue_trip',
    maxRanks: 1,
    entryIds: [117144],
    definitionIds: [{ id: 122156, specId: 261 }],
  },
  UNSEEN_BLADE_TALENT: {
    id: 441146,
    name: 'Unseen Blade',
    icon: 'inv_weapon_shortblade_55',
    maxRanks: 1,
    entryIds: [117737],
    definitionIds: [{ id: 122749, specId: 261 }],
  },
  UNSHAKEABLE_DRIVE_TALENT: {
    id: 1248774,
    name: 'Unshakeable Drive',
    icon: 'ability_warrior_deepcuts',
    maxRanks: 1,
    entryIds: [117732],
    definitionIds: [{ id: 122744, specId: 261 }],
  },
  VEILTOUCHED_TALENT: {
    id: 382017,
    name: 'Veiltouched',
    icon: 'spell_arcane_prismaticcloak',
    maxRanks: 1,
    entryIds: [112601],
    definitionIds: [{ id: 117606, specId: 261 }],
  },
  VENOMOUS_WOUNDS_TALENT: {
    id: 79134,
    name: 'Venomous Wounds',
    icon: 'ability_rogue_venomouswounds',
    maxRanks: 1,
    entryIds: [112661],
    definitionIds: [{ id: 117666, specId: 259 }],
  },
  VIGOR_TALENT: {
    id: 14983,
    name: 'Vigor',
    icon: 'ability_rogue_vigor',
    maxRanks: 2,
    entryIds: [112651],
    definitionIds: [{ id: 117656, specId: 261 }],
  },
  VIRULENT_POISONS_TALENT: {
    id: 381543,
    name: 'Virulent Poisons',
    icon: 'ability_creature_poison_06',
    maxRanks: 1,
    entryIds: [112638],
    definitionIds: [{ id: 117643, specId: 261 }],
  },
  WARNING_SIGNS_TALENT: {
    id: 426555,
    name: 'Warning Signs',
    icon: 'achievement_bg_kill_flag_carrier',
    maxRanks: 1,
    entryIds: [117172],
    definitionIds: [{ id: 122184, specId: 261 }],
  },
  WEAPONMASTER_TALENT: {
    id: 193537,
    name: 'Weaponmaster',
    icon: 'ability_ironmaidens_bladerush',
    maxRanks: 1,
    entryIds: [112627],
    definitionIds: [{ id: 117632, specId: 261 }],
  },
  WITHOUT_A_TRACE_TALENT: {
    id: 382513,
    name: 'Without a Trace',
    icon: 'ability_vanish',
    maxRanks: 1,
    entryIds: [125614],
    definitionIds: [{ id: 130446, specId: 261 }],
  },
  ZERO_IN_TALENT: {
    id: 1259485,
    name: 'Zero In',
    icon: 'ability_hisek_aim',
    maxRanks: 1,
    entryIds: [112557],
    definitionIds: [{ id: 117562, specId: 260 }],
  },
  ZOLDYCK_RECIPE_TALENT: {
    id: 381798,
    name: 'Zoldyck Recipe',
    icon: 'archaeology_5_0_thunderkinginsignia',
    maxRanks: 2,
    entryIds: [112678],
    definitionIds: [{ id: 117683, specId: 259 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_ROGUE };
